// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"OgxL4","submit":"_3qUec","verification":"oRssp","dash":"_3uHE2"};